<template>
    <div class="user-info">

        <el-dropdown trigger="click" @command="handleCommand">

              <span class="el-dropdown-link" >
                  <img :src="imgUrl" class="user-i" alt="" style='width:30px;height:30px;'/>
                    <span>{{ department ? department + " / " + name : '' + (name ? name : username) }}</span>
                    <i class="iconfont icon-lower-triangle user-icon"></i>
                </span>
            <el-dropdown-menu slot="dropdown">
                <div class="dropdown-menu-tit">欢迎使用!</div>
                <el-dropdown-item command="myComplaints">
                    <span>我的投诉</span>
                </el-dropdown-item>
                <el-dropdown-item command="addMyComplaints">
                    <span>我要投诉</span>
                </el-dropdown-item>
                <!--<el-dropdown-item command="UpdatePassword">-->
                    <!--<span class="iconfont icon-dingbulan-xiugaimima"></span>修改密码-->
                <!--</el-dropdown-item>-->
                <el-dropdown-item command="loginout"><span class="iconfont icon-logout" ></span>退出</el-dropdown-item>
                <!--<el-dropdown-item command="skin"><span class="iconfont icon-dingbulan-pifuqiehuan"></span>换肤</el-dropdown-item>-->
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
import ssoService from '../services/sso.service.js'
    export default {
        props:{
            shutDownTitle:Function
        },
        name: "user-info",
        computed: {
            userInfo(){
                return this.$store.state.userInfo || {};
            },
            getSkinName(){
                return this.$store.state.skinName;
            }
        },
        data () {
            return {
                imgUrl: '',
                department: '',
                name: '',
                username: ''
            }
        },
        mounted() {
            this.imgUrl = window.localStorage.getItem('avatar')
            this.department = window.localStorage.getItem('department')
            this.name = window.localStorage.getItem('name')
            this.username = window.localStorage.getItem('wedof_itsm_web_user_name')
        },
        methods: {
            handleCommand (command) {
                switch (command) {
                    case 'loginout' :
                        this.loginOut();
                        break;
                    case 'UpdatePassword':
                        this.$router.push({
                            path: "/updatePassword",
                            query: {
                                userId: this.$store.state.userInfo.userId
                            }
                        });
                        break;
                    case "skin":
                        this.chageSkin();
                        break;
                    case "myComplaints":
                        this.$router.push({
                            path:'/myComplaints',
                            query:{

                            }
                        });
                        break;
                    case "addMyComplaints":
                        this.$router.push({
                            path:'/addMyComplaints',
                            query:{

                            }
                        });
                        break
                }
            },
            chageSkin(){
                let skinName = this.getSkinName;
                let skin = JSON.parse(window.localStorage.getItem(skinName));
                let changeSkin = !skin;
                window.localStorage.setItem(skinName,changeSkin);
                let theme = changeSkin ? 'theme1' : 'theme2';
                window.document.documentElement.setAttribute('data-theme',theme);
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText
                }).then(() => {
                    doit();
                }).catch(() => {
                });
            },
            loginOut () {
                this.openMessage('您确定要退出吗？', '确定', () => {
                    this.shutDownTitleChange()
                    this.$store.dispatch('logout')
                        .then(rs => {
                            this.$cookies.remove("user_name")
                            this.$cookies.remove("token")
                            this.$cookies.remove("operator_token")
                            this.$cookies.remove("operator_sign")
                            this.$cookies.remove("operator_timestamp")
                            window.localStorage.clear()
                            this.$message({type: 'success', message: '退出成功'})
                            this.$page.closeAll()//推出的时候顺带关闭面包屑里的所有页面，重新登陆同一账号时只剩下首页
                            location.href='#/login'
                        })
                        .catch(err => {
                            this.$message.error(err.message)
                            // if (err.code === 20107) {
                            //     this.$message({
                            //         showClose: true,
                            //         message: "账号校验失败，请重新登录",
                            //         type: 'error'
                            //     });
                            //     setTimeout(() => {
                            //         this.$router.replace('login');
                            //     },500)

                            // }
                    });
                })
            },
            shutDownTitleChange(){
                this.shutDownTitle()
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">


</style>
